export const getWorkspaceAccessToken = async (token, workspaceId) => {
	try {
		const url = new URL(
			`${process.env.REACT_APP_PORT}/user/getAccessToken/${workspaceId}`
		);
		const response = await fetch(url, {
			method: "GET",
			headers: { Authorization: `Bearer ${token}` },
		});

		const data = await response.json();
		return data.access_token;
	} catch (error) {
		return error;
	}
};
